import { render, staticRenderFns } from "./GeneralStats.vue?vue&type=template&id=1c0be29a&scoped=true&"
import script from "./GeneralStats.vue?vue&type=script&lang=js&"
export * from "./GeneralStats.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStats.vue?vue&type=style&index=0&id=1c0be29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0be29a",
  null
  
)

export default component.exports